// This file added by Bearer Web Developer
import React from 'react'
import styles from './chatNotification.module.scss';
import { observer } from 'mobx-react-lite';
import { IChatState } from '../../../../states/app-state';
import { useThemeMode } from '../../../../states/contexts/theme';
interface Props {
    scrollToMessageBox: () => void,
    chat: IChatState
}
const ChatNotification: React.FC<Props> = observer(({ scrollToMessageBox, chat }) => {
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <div onClick={scrollToMessageBox} className={styles.chat_notification} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <img src="/bottom-mark.svg" alt="scroll-top" width={16} height={16} />
            {chat.changeDataCount > 0 && <span className={styles.count}>{chat.changeDataCount}</span>}
        </div>
    )
});
export default ChatNotification;